global.modules.set({
  async init(context) {
    $('.short_text', context).each(function () {
      var elem = $(this);
      var text = elem.html();
      var textContent = elem.text();
      if (text.length > 180) {
        var shortText = textContent.slice(0, 180) + '...';
        var moreText = $('<button type="button" class="text-arapawa font-RobotoMedium hoverable text-hover-danube bg-transparent p-0 mt-2">+ Show more</button>').insertAfter(elem);
        var lessText = $('<button type="button" class="text-arapawa font-RobotoMedium hoverable text-hover-danube bg-transparent p-0 mt-2" hidden>- Show less</button>').insertAfter(elem);
        elem.empty().append(shortText);
        moreText.on('click', function () {
          moreText.attr('hidden', true);
          lessText.attr('hidden', false);
          elem.empty().append(text);
        })
        lessText.on('click', function () {
          moreText.attr('hidden', false);
          lessText.attr('hidden', true);
          elem.empty().append(shortText);
        })
      }
    })

    $('.short_text_note', context).each(function () {
      var elem = $(this);
      var text = elem.html();
      var textContent = elem.text();
      if (text.length > 60) {
        var shortText = textContent.slice(0, 60) + '...';
        elem.empty().append(shortText);
      }
    })
  }
})